<template>
    <div>
        <v-layout wrap>
            <v-flex>
                <v-toolbar
                        color="blue-grey"
                        dark
                        fixed
                        app
                        clipped-right
                        class="elc-card"
                >
                    <v-icon @click="sideNav = !sideNav" class="elc-header-icon">menu</v-icon>
                    <div style="cursor: pointer !important;" @click="goToOverview">
                        <h1>ELECTORAL LITERACY CLUB</h1>
                    </div>

                    <v-spacer></v-spacer>

                    <div class="elc-announcement">
                        <img src="../../../static/assets/image/announcementHeader.png"
                             title="Announcement"
                             @click="openAnnouncementDelDialog()">
                    </div>

                    <v-tooltip bottom class="p-20">
                        <v-avatar slot="activator" size="36px"
                                  style="color: #515a75;font-weight:bold;font-size: 20px;background-color: #fff">
                            <span>  {{ loginUser[0] }}</span>
                        </v-avatar>
                        <span> {{ loginUser }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <v-btn class="text-sm-center" slot="activator" icon v-on:click="openDialog">
                            <v-icon>settings_power</v-icon>
                        </v-btn>
                        <span>Logout</span>
                    </v-tooltip>
                </v-toolbar>

            </v-flex>
            <v-spacer></v-spacer>
        </v-layout>
        <v-navigation-drawer absolute clipped temporary v-model="sideNav" app class="elc-side-menu"
                             @keydown.esc
        >
            <v-list v-if="user.officer_role == 0">
                <v-list-tile class="elc-box-list" :to="'/myclubs/district/taluka/club'">
                    <span class="elc-lable">My Clubs </span>
                </v-list-tile>
                <v-list-tile class="elc-box-list" :to="'/knowledgebase'">
                    <span class="elc-lable">Knowledge Base</span>
                </v-list-tile>
                <v-list-tile class="elc-box-list" :to="'/settings'">
                    <span class="elc-lable">Settings</span>
                </v-list-tile>
            </v-list>

            <v-list v-else>
                <v-list-tile class="elc-box-list" v-for="(menu,index) in menuItems1" :key="index" :to="menu.path">
                    <span class="elc-lable">{{menu.title}} </span>

                </v-list-tile>
                <v-list-group>
                    <v-list-tile slot="activator">
                        <span class="elc-lable1">ELC Clubs</span>
                    </v-list-tile>

                    <v-list-tile v-if="user.officer_role !== 5" class="elc-box-list" :to="'/myclubs/district/taluka/club'">
                        <span class="elc-lable p-l-32">My Clubs</span>
                    </v-list-tile>

                    <v-list-tile class="elc-box-list" :to="'/clubs/district/taluka/club'">
                        <span class="elc-lable p-l-32">All Clubs</span>
                    </v-list-tile>

                </v-list-group>

                <v-list-tile class="elc-box-list" :to="'/knowledgebase'">
                    <span class="elc-lable">Knowledge Base</span>
                </v-list-tile>
                <v-list-tile class="elc-box-list" :to="'/settings'">
                    <span class="elc-lable">Settings</span>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-dialog v-model="confirmDialog" persistent max-width="290">
            <v-card>
                <v-card-text>Are you sure, you want to logout ?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="elc-button-radius" flat @click.native="confirmDialog = false">Cancel</v-btn>
                    <v-btn class="elc-button-radius-color" flat @click.native="logout">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="announcementDialog" persistent max-width="400px" max-height="600px"
                  @keydown.esc="cancelAnnoucementDialog">
            <v-form v-model="valid" lazy-validation style="text-transform: capitalize;" ref="formAN">
                <v-card>
                    <v-tooltip bottom>
                        <v-btn slot="activator" style="float: right !important;" icon @click="cancelAnnoucementDialog">
                            <v-icon>clear</v-icon>
                        </v-btn>
                        <span>Close</span>
                    </v-tooltip>

                    <v-card-text class="p-10">
                        <v-card-title class="p-0 p-l-10">
                            <span class="headline">Announcement </span>
                        </v-card-title>
                        <v-container grid-list-md class="p-10">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-if="announcementDialog"
                                                autofocus
                                                name="title"
                                                v-model="title"
                                                label="Title"
                                                :rules="fieldRules"
                                        ></v-text-field>
                                    </v-flex>

                                </v-flex>

                                <v-flex xs12>
                                    <v-textarea
                                            name="description"
                                            v-model="description"
                                            label="Description"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn class="elc-button-radius" flat @click="cancelAnnoucementDialog">Cancel</v-btn>

                        <v-btn class="elc-button-radius-color" flat :disabled="title == ''"
                               @click="addAnnoucement">Save
                        </v-btn>


                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>


    </div>
</template>

<script>
    import Common from '../Common/Constants'
    import Vue from 'vue'

    export default {
        name: "ElcHeader",
        data() {
            return {
                constant: Common,
                confirmDialog: false,
                logoutFlag: false,
                // user: '',
                sideNav: false,

                menuItems1: [
                    {title: 'Overview', path: '/clubcount'},
                    {title: 'ELC Officers', path: '/officers'},
                ],
                /*clubItems: [
                    {
                        title: 'ELC Clubs',
                        items: [
                            {title: 'All Clubs', path: '/Clubs/dist/ta/club'},
                            {title: 'My Clubs', path: '/Clubs/1/ta/club'}
                        ]
                    },
                ],
                menuItems2: [
                    {title: 'Knowledge Base', path: '/KnowledgeBase'}
                ],*/
                title: '', description: '', valid: false, announcementDialog: false,
                fieldRules: [
                    v => !!v || 'This field is required',
                ],
                successToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'success-toast'
                },
                errorToast: {
                    theme: "primary",
                    position: "top-right",
                    duration: 3000,
                    className: 'error-toast'
                },
                user: {}, club_id: '',
                myClubFlag: false,
            }
        },
        created() {
            let self = this;
            let token = localStorage.getItem('token');
            self.user = JSON.parse(localStorage.getItem('user'));
            self.loginUser = self.user.lname == null ? self.user.fname : self.user.fname + ' ' + self.user.lname;
            /*if (self.user.officer_role === 5) {
                self.constant.rolePrefix = [
                    {id: 0, value: 'Nodal Officer'},
                    {id: 1, value: 'AERO Officer'},
                    {id: 2, value: 'ERO Officer'},
                ]
            } else*/
            if (self.user.officer_role === 4) {
                self.constant.rolePrefix = [
                    {id: 0, value: 'Nodal Officer'},
                    {id: 1, value: 'AERO Officer'},
                    {id: 2, value: 'ERO Officer'},
                    {id: 3, value: 'DY DEO Officer'},
                ]
            } else if (self.user.officer_role === 3 || self.user.officer_role === 5) {
                self.constant.rolePrefix = [
                    {id: 0, value: 'Nodal Officer'},
                    {id: 1, value: 'AERO Officer'},
                    {id: 2, value: 'ERO Officer'},
                    {id: 5, value: 'Staff'},
                ]
            } else if (self.user.officer_role === 2) {
                self.constant.rolePrefix = [
                    {id: 0, value: 'Nodal Officer'},
                    {id: 1, value: 'AERO Officer'},
                ]
            } else if (self.user.officer_role === 1) {
                self.constant.rolePrefix = [
                    {id: 0, value: 'Nodal Officer'},
                ]
            } else {
                self.constant.rolePrefix = self.constant.rolePrefix
            }
            if (token === '' || token === undefined || token === null) {
                self.$router.push('/')
            }
            self.header = {
                "Content-Type": "application/json",
                "token": token,
            };
            if (self.user.officer_role === 0) {
                self.club_id = JSON.parse(localStorage.getItem('club_details')).club_id;
            }
            // this.myClubFlag=Vue.prototype.$myClubFlag
            // console.log("**",this.myClubFlag)
        },
        methods: {
            /*goToMyClubs() {
                let self = this;
                Vue.prototype.$myClubFlag = true;
                if (self.$route.name == 'Clubs') {
                    self.$router.go(0)
                } else {
                    self.$router.push('/Clubs/dist/ta/club');
                }
                console.log("Vue.prototype.$myClubFlag", Vue.prototype.$myClubFlag)
            },
            goToAllClubs() {
                let self = this;
                Vue.prototype.$myClubFlag = false;
                if (self.$route.name == 'Clubs') {
                    self.$router.go(0)
                } else {
                    self.$router.push('/Clubs/dist/ta/club');
                }
                console.log("Vue.prototype.$myClubFlag", Vue.prototype.$myClubFlag)
            },*/

            openDialog: function () {
                let self = this;
                self.confirmDialog = true;
            },
            logout: function () {
                let self = this;
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.clear();
                self.$session.destroy();
                self.$router.push('/');
            },
            goToOverview() {
                let self = this;
                self.$router.push('/');
            },
            openAnnouncementDelDialog() {
                let self = this;
                self.title = '';
                self.description = '';
                self.an_club_id = '';
                self.$refs.formAN.reset();
                self.announcementDialog = true;

            },
            cancelAnnoucementDialog() {
                let self = this;
                self.announcementDialog = false;
                self.title = '';
                self.description = '';
                self.$refs.formAN.reset();
            },
            addAnnoucement() {
                let self = this;
                self.announcementDialog = false;
                let request = {
                    "club_id": '',
                    'text': self.title,
                    'description': self.description,
                };
                axios.post(self.constant.apiUrl + "create/announcement", request)
                    .then(function (response) {
                        if (response.data.flag) {
                            self.$toasted.show('Announcement created', self.successToast);
                        }
                        else {
                            self.$toasted.show(response.data.message, self.errorToast);
                        }
                    })


            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common/ElcHeader.vue